
import React from 'react';
import narilart from '../assets/narilart.jpg';

const OurStory = () => {
  return (
    <>
        <section className="about-section pt-5 animate-form animate-form-4 pt-4">
      <div className="container">
       
        <div className="row align-items-center">
          {/* <!-- Image Column --> */}
          <div className="col-sm-6 text-center ">
            <img src={narilart} alt="" className="img-fluid rounded aboutus-img" />
          </div>
          {/* <!-- Content Column --> */}
          <div className="col-sm-6">
            <h2 className="text-center mb-4"  style={{color: "#b37777", fontstyle: "italic", fontfamily: '"TAN TWINKLE", cursive'}}>Our Story</h2>
            <p>
              “MSilk Spa is a trusted part of the Brooklyn community. With a focus on quality,
               creativity, and personalized service, we’ve built a loyal clientele who trust us with their beauty and wellness needs.”            
              </p>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default OurStory;